import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { FEED_OPTIONS } from "%/dynamic-component-editor/constants/feed-options";
import { camelToTitleCase } from "@bloglovin/vue-framework";
import SmartFeedSelection from "%/dynamic-component-editor/options/smart-feed-selection";

export default class SmartFeedLayout extends BaseOption {
  static label = "Layout";

  static userInterfaceComponent = optionValues => {

    if (!optionValues) {
      return {
        component: inspectorTools.SIMPLE_PICKER,
        props: {
          options: [
            { id: "grid", name: "Grid" },
            { id: "list", name: "List" },
            { id: "carousel", name: "Carousel" },
          ],
        },
      };
    }

    const smartFeedSelection = new SmartFeedSelection().getValueFromConfiguration(optionValues);
    const config = FEED_OPTIONS[smartFeedSelection];

    if (!config) {
      return {
        component: inspectorTools.SIMPLE_PICKER,
        props: {
          options: [
            { id: "grid", name: "Grid" },
            { id: "list", name: "List" },
            { id: "carousel", name: "Carousel" },
          ],
        },
      };
    }
    const layoutOptions = config.layouts.map(layout => {
      return {
        id: layout,
        name: camelToTitleCase(layout, true),
      };
    });

    return {
      component: inspectorTools.SIMPLE_PICKER,
      props: {
        options: layoutOptions,
      },
    };
  };

  static defaultValue = "grid";
}
